import React from 'react';
// import styled from 'styled-components';

import SearchIcon from './assets/images/ic-search.svg';
import EditIcon from './assets/images/ic-edit.svg';
import AddIcon from './assets/images/ic-add.svg';
import DeleteIcon from './assets/images/ic-delete.svg';
import FileUpload from './assets/images/ic-file-upload.svg';
import FormatBold from './assets/images/ic-format-bold.svg';
import FormatItalic from './assets/images/ic-format-italic.svg';
import EmbedVideo from './assets/images/ic-file-upload.svg';
import EmbedImage from './assets/images/ic-embed-image.svg';
import EmbedLink from './assets/images/ic-embed-link.svg';
import listUl from './assets/images/list-ul.svg';
import listOl from './assets/images/list-ol.svg';

const Icons = {
  search: SearchIcon,
  edit: EditIcon,
  add: AddIcon,
  delete: DeleteIcon,
  fileUpload: FileUpload,
  formatBold: FormatBold,
  formatItalic: FormatItalic,
  embedVideo: EmbedVideo,
  embedImage: EmbedImage,
  embedLink: EmbedLink,
  listUl:listUl,
  listOl:listOl
}
const iconFor = iconName => Icons[iconName]

export default function Icon(props) {
  return <img alt="icon"
    {...props} 
    src={iconFor(props.name)}
    style={{
      height: "38px",
      padding: "8px",
      filter: "invert(99%) sepia(1%) saturate(2%) hue-rotate(345deg) brightness(103%) contrast(103%)",
      background: `${props.withBackground ? "black" : "none"}`,
      cursor: "pointer",
    }}
  />
}

// const Tid = styled.img`
//   height: 38px;
//   padding: 8px;
//   border: "1px solid black";
//   filter: invert(99%) sepia(1%) saturate(2%) hue-rotate(345deg) brightness(103%) contrast(103%);
//   background: ${props => props.withBackground ? "black" : "none"};
//   cursor: pointer;
// `